import { RuntimeEnv } from 'app/core/types/runtime-env';

/** #1412: a non-production build (environment.ts/environment.local.ts, both used by
 * plain `npm start`) must not report to the real Sentry org. */
export function shouldEnableSentry(
    production: boolean,
    env: Pick<RuntimeEnv, 'sentryEnableInDev'>,
): boolean {
    return production || env.sentryEnableInDev === true;
}
